/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_Title_2Inputs */

const en_services_cta_title_2 = /** @type {(inputs: Services_Cta_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’ll help shape the system.`)
};

const lv_services_cta_title_2 = /** @type {(inputs: Services_Cta_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmu veidosim kopā.`)
};

/**
* | output |
* | --- |
* | "We’ll help shape the system." |
*
* @param {Services_Cta_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_cta_title_2 = /** @type {((inputs?: Services_Cta_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_cta_title_2(inputs)
	return en_services_cta_title_2(inputs)
});